import { AppProvider, useApp } from './context/AppContext';
import { 
  Confetti, 
  Toast, 
  Navigation, 
  Onboarding, 
  AchievementPopup 
} from './components/common';
import { Home } from './components/Home/Home';
import { Calculator } from './components/Calculator/Calculator';
import { Actions } from './components/Actions/Actions';
import { Share } from './components/Share/Share';
import { AIAssistant } from './components/AI';
import { AIProvider } from './context/AIContext';

function MainContent() {
  const { view } = useApp();

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "1.5rem 1rem 5rem" }}>
      {view === "home" && <Home />}
      {view === "calculator" && <Calculator />}
      {view === "actions" && <Actions />}
      {view === "ai" && <AIAssistant />}
      {view === "share" && <Share />}
      
      {/* Footer */}
      <footer 
        style={{ 
          marginTop: "3rem", 
          paddingTop: "1.5rem", 
          borderTop: "1px solid var(--border-color)", 
          textAlign: "center" 
        }}
      >
        <div style={{ fontSize: "0.75rem", color: "var(--text-muted)", fontStyle: "italic" }}>
          Created by Tarun Agarwal
        </div>
      </footer>
    </div>
  );
}

function AppShell() {
  const { theme } = useApp();

  return (
    <div
      data-theme={theme}
      style={{
        fontFamily: "'Palatino Linotype', Palatino, serif",
        background: "var(--bg-primary)",
        minHeight: "100vh",
        color: "var(--text-primary)",
        transition: "background-color 0.2s ease, color 0.2s ease",
      }}
    >
      <style>{`
        * { box-sizing: border-box; }
        @keyframes fadeIn { from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)} }
        @keyframes slideIn { from{opacity:0;transform:translateX(16px)}to{opacity:1;transform:translateX(0)} }
        @keyframes fadeUp { from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)} }
        button { cursor: pointer; font-family: inherit; transition: opacity 0.15s; }
        button:hover { opacity: 0.85; }
        input, select { font-family: inherit; }
        ::-webkit-scrollbar{width:5px}
        ::-webkit-scrollbar-track{background:var(--scrollbar-track)}
        ::-webkit-scrollbar-thumb{background:var(--scrollbar-thumb);border-radius:3px}

        /* Focus styles for accessibility */
        button:focus-visible, input:focus-visible, select:focus-visible {
          outline: 2px solid #4ade80;
          outline-offset: 2px;
        }

        /* Smooth hover transitions */
        button:not(:disabled):hover {
          transform: translateY(-1px);
        }

        /* Selection color */
        ::selection {
          background: rgba(74, 222, 128, 0.3);
          color: var(--text-primary);
        }
      `}</style>

      <Confetti />
      <Onboarding />
      <Toast />
      <AchievementPopup />
      <Navigation />
      <MainContent />
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <AIProvider>
        <AppShell />
      </AIProvider>
    </AppProvider>
  );
}

export default App;
